<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <header_promotion_name :img_header="header_image" header="สินค้าคละ" :promotion_code="header_list.promotion_code" link_back="stock/promotion_stock/promotionassorted"/>
      <v-card elevation="6">
        <div class="grid_half">
          <div class="pa-2">
            <div class="mt-4">
              <v-img height="200" max-width="200" v-if="header_list.pic === ''" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
              <v-img height="200" max-width="200" v-if="header_list.pic !== ''" :lazy-src="img_holder" :src="header_list.pic" class="preview mx-auto"></v-img>
            </div>
          </div>
          <div class="pa-2">
            <div class="grid_full">
              <div class="ml-3 mt-6 mr-4 grid_flex">
                <div class="detail_flex">
                  <div>วันที่สิ้นสุดโปรโมชั่น :</div>
                  <div class="ml-3">{{ date }}</div>
                </div>
                <div class="detail_flex">
                  <div>ยอดขาย :</div>
                  <div><span class="ml-3 mr-3">{{ format_price(header_list.count_sale) }}</span>บาท</div>
                </div>
              </div>
              <div class="ml-3 mr-4 grid_flex">
                <div class="detail_flex">
                  <div>จำนวนในการคละ :</div>
                  <div><span class="ml-3 mr-3">{{ header_list.qty_per_set }}</span>ชิ้น</div>
                </div>
                <div class="detail_flex">
                  <div>ราคาขาย :</div>
                  <div><span class="ml-3 mr-3">{{ format_price(header_list.price_per_set) }}</span>บาท</div>
                </div>
              </div>
              <div class="ml-3 mr-4 grid_flex">
                <div class="detail_flex">
                  <div>แสดงสถานะการขาย :</div>
                  <div class="black--text ml-3 mr-3" v-if="header_list.show_promotion_set === '1'">แสดงทั้งขายปลีก, ขายส่ง</div>
                  <div class="black--text ml-3 mr-3" v-else-if="header_list.show_promotion_set === '2'">แสดงเฉพาะขายปลีก</div>
                  <div class="black--text ml-3 mr-3" v-else-if="header_list.show_promotion_set === '3'">แสดงเฉพาะขายส่ง</div>
                </div>
              </div>
            </div>
            <div class="ml-3 mt-3 mr-1 d_mobile">
              <div>รายละเอียดโปรโมชั่น :</div>
              <div>{{ header_list.detail }}</div>
            </div>
          </div>
        </div>
        <div class="pa-4">
          <v-card-title>
            <div>
              สินค้าในเงื่อนไข
            </div>
          </v-card-title>
          <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>{{ format_price(dataDetail.item.cost_avg) }}</td>
                <td>{{ dataDetail.item.unit_name }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-divider/>
          <div v-if="date_raw >= date_now" class="pa-4 pt-6">
            <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_at" :status="header_list.status"/>
          </div>
          <div v-else class="pa-4 pt-6">
            <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_at" :status="0"/>
          </div>
          <div class="text-center mt-4 mt-3">
            <v-btn height="45" class="white--text grad-warning-bg btn_mobile" type="button" @click="getEdit(header_list.id)">แก้ไขโปรโมชั่น</v-btn>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import header_promotion_name from "@/components/admin/stock/storage_promotion/header_promotion/header_promotion_name";
import img_holder from "@/assets/pharmacy.png";
import usercreate_promotion from "@/components/admin/stock/storage_promotion/header_promotion/usercreate_promotion";
import HeaderImage from "@/assets/boxes_random.png";
import {HTTP} from "@/axios";
import {formatPrice} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_details_group",
  components: {
    usercreate_promotion,
    header_promotion_name
  },
  data() {
    return {
      loading_page: false,
      search: null,
      date: '',
      date_raw: '',
      date_now: null,
      header_image: HeaderImage,
      img_holder: img_holder,
      pro_pic_name: null,
      imagePreviewURL: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาต้นทุนเฉลี่ย',
          value: 'cost_avg',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '150px',
        },
      ],
      header_list: [],
      data_list: [],
    }
  },
  methods: {
    get_date() {
      let date_today = new Date();
      let day = date_today.getDate();
      let month = date_today.getMonth() + 1;
      let year = date_today.getFullYear();
      // if (month < 10){
      //   month = '0'+ month
      // }
      // if (day < 10){
      //   day = '0'+ day
      // }
      let date = year + '-' + month + '-' + day
      this.date_now = Date.parse(date)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const total_date = day+'/'+month+'/'+year
      return this.date = total_date
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/promotions/sets/getbyid', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.object.head
          if (res.data.object.head.date_end !== null) {
            this.date_raw = Date.parse(res.data.object.head.date_end)
            this.date = res.data.object.head.date_end
            this.diffDateTH(this.date)
          }
          else {
            this.date = ''
          }
          this.data_list = res.data.object.list
        }
      })
    },
    getEdit() {
      const id = this.$route.params.id;
      this.$router.push('/stock/promotion_stock/promotioneditgroup/' + id)
    }
  },
  mounted() {
    this.get_date()
    this.get_data()
  }
}
</script>

<style scoped>
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.detail_flex {
  display: flex;
  justify-content: space-between;
}
.grid_half {
  display: grid;
  grid-template-columns: 30% 70%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.preview {
  border-radius: 8px;
}
.d_mobile {
  display: grid;
  grid-template-columns: 100%;
}
@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_full {
    display: grid;
    grid-template-columns: 100%;
    margin-top: 40px;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
